export default {
  mailbookTitle: {
    id: 'bo_seller.profile.contact_details.mailbook.title',
    defaultMessage: 'Additional contacts',
  },
  description: {
    id: 'bo_seller.profile.contact_details.mailbook.description',
    defaultMessage:
      'Add as many team members as you want. Just let us know what kind of automated emails they need to receive.',
  },
  emailLabel: {
    id: 'bo_seller.profile.contact_details.mailbook.email_label',
    defaultMessage: 'Email address',
  },
  emailPlaceholder: {
    id: 'bo_seller.profile.contact_details.mailbook.email_placeholder',
    defaultMessage: 'Email address',
  },
  contactTypeLabel: {
    id: 'bo_seller.profile.contact_details.mailbook.contact_type_label',
    defaultMessage: 'Type of contact',
  },
  contactTypePlaceholder: {
    id: 'bo_seller.profile.contact_details.mailbook.contact_type_placeholder',
    defaultMessage: 'Type of contact',
  },
  addContactButton: {
    id: 'bo_seller.profile.contact_details.mailbook.add_contact_button',
    defaultMessage: 'Add contact',
  },
  warningTitle: {
    id: 'bo_seller.profile.contact_details.mailbook.warning_title',
    defaultMessage: 'The following users have not been allocated contact types',
  },
  warningCaption: {
    id: 'bo_seller.profile.contact_details.mailbook.warning_caption',
    defaultMessage: 'Click to expand/collapse',
  },
  emailRequired: {
    id: 'bo_seller.profile.contact_details.mailbook.email_required',
    defaultMessage: 'The email field is required',
  },
  emailInvalid: {
    id: 'bo_seller.profile.contact_details.mailbook.email_invalid',
    defaultMessage: 'This email seems to be invalid',
  },
  fieldIsRequired: {
    id: 'bo_seller.profile.contact_details.mailbook.field_required',
    defaultMessage: 'This field is required',
  },
  toastAddSuccessContent: {
    id: 'bo_seller.profile.contact_details.mailbook.toast_add_success',
    defaultMessage: 'Contact added successfully',
  },
  toastErrorContent: {
    id: 'bo_seller.profile.contact_details.mailbook.toast_error',
    defaultMessage: 'An error occurred while adding the contact',
  },
  noContacts: {
    id: 'bo_seller.profile.contact_details.mailbook.no_contacts',
    defaultMessage: 'No contacts for this type yet',
  },
  allEmails: {
    id: 'bo_seller.profile.contact_details.mailbook.all_emails',
    defaultMessage: 'All emails',
  },
  email: {
    id: 'bo_seller.profile.contact_details.mailbook.email',
    defaultMessage: 'Email',
  },
  loadingText: {
    id: 'bo_seller.profile.contact_details.mailbook.loading_text',
    defaultMessage: 'Loading...',
  },
  toastDeleteSuccessContent: {
    id: 'bo_seller.profile.contact_details.mailbook.toast_delete_success',
    defaultMessage: 'Contact deleted successfully',
  },
  toastDeleteErrorContent: {
    id: 'bo_seller.profile.contact_details.mailbook.toast_delete_error',
    defaultMessage: 'An error occurred while deleting the contact',
  },
  deleteModalTitle: {
    id: 'bo_seller.profile.contact_details.mailbook.delete_modal_title',
    defaultMessage: 'Delete contact',
  },
  deleteModalPrompt: {
    id: 'bo_seller.profile.contact_details.mailbook.delete_modal_prompt',
    defaultMessage: 'Are you sure you want to delete this contact?',
  },
  deleteModalConfirm: {
    id: 'bo_seller.profile.contact_details.mailbook.delete_modal_confirm',
    defaultMessage: 'Yes, delete contact',
  },
  deleteModalCancel: {
    id: 'bo_seller.profile.contact_details.mailbook.delete_modal_cancel',
    defaultMessage: 'No, keep contact',
  },
  toggleMore: {
    id: 'bo_seller.profile.contact_details.mailbook.toggle_more',
    defaultMessage: 'Toggle',
  },
}
